var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeedInvestorsAllocationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 661.6 787.5",
    style: {
      enableBackground: "new 0 0 661.6 787.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M660,467.5l-62.2-163.8c0,0-6.6-65-12.5-90C559.4,101.9,434.4,0,298.8,0C133.8,0.3,0,134.4,0,299.4 c0,91.6,42.2,178.1,114.1,234.7v253.4h318.8v-85h46.9c65,0,117.8-52.8,117.8-117.8l0,0v-83.8h39.7c13.4,0,24.4-10.9,24.4-24.4l0,0 C661.9,473.4,661.2,470.6,660,467.5z M297.5,448.4c-90.6,0-164.1-73.4-164.1-164.1s73.4-164.1,164.1-164.1s163.8,73.4,164.1,164.1 l0,0c0.3,90.3-72.8,163.7-163.1,164.1C297.8,448.4,297.8,448.4,297.5,448.4L297.5,448.4z M313.1,268.4c-22.5-9.4-33.1-13.4-33.1-25 c0-8.1,9.1-16.6,25.6-16.6c12.5,0.3,25,3.1,36.2,8.1l9.1-32.2c-13.1-6.6-27.8-9.7-42.5-9.4v-25.6h-22.8V195 c-30.3,6.2-46.9,25.6-46.9,50.6c0,27.2,18.8,42.2,48.8,52.8c21.6,8.4,30.6,13.1,30.6,24.4c0,11.2-9.1,19.7-28.1,19.7 c-15.6-0.3-30.6-4.4-44.4-11.2l-8.1,33.1c9.7,5.3,29.4,10.6,48.7,10.6v25h22.8v-25.6c33.1-7.5,48.8-26.9,48.8-52.8 S344.1,279.7,313.1,268.4L313.1,268.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeedInvestorsAllocationIcon);
export default __webpack_public_path__ + "static/media/seed_investors_allocation_icon.9618761c58d9ee5c4dee38d9eb0385d6.svg";
export { ForwardRef as ReactComponent };